<div class="lead-model-tabs main-tabs">
  <div class="mb-3 d-flex align-items-center" [ngClass]="embedded ? 'justify-content-end' : 'justify-content-between'">
    <p class="f-24 _fw-600" *ngIf="!embedded">Create Lead</p>
    <div class="d-flex align-items-center gap-2">
      <div class="d-flex align-items-center gap-2" *ngIf="leadForm.controls['lead_type'].value == 'Agent'">
        <p class="mb-2">Agency</p>
        <label for="" style="width: 320px">
          <re-multiselect
            [module]="'contacts'"
            [type]="'Company'"
            [company_type]="'Agency'"
            [placeholder]="'Select'"
            [agent_id]="leadForm.controls['contactid'].value ? leadForm.controls['contactid'].value : null"
            [truncate]="25"
            [isMultiple]="false"
            [isClear]="true"
            [selected_ids]="existingCompanyId"
            (onUpdate)="onUpdateSelect('company', $event)"
            [isFullObject]="true"
            [style]="{ width: '100%' }"
            [isEmail]="true">
          </re-multiselect>
        </label>
      </div>
      <div class="d-flex align-items-center gap-2">
        <div [ngClass]="{ 'ml-2': addDefaultFields?.listing }" class="d-flex align-items-center gap-2">
          <p class="mb-2">{{ leadForm.controls['lead_type'].value == 'Agent' ? 'Agent' : 'Existing Clients' }}</p>
          <label for="" style="width: 320px">
            <re-multiselect
              [module]="'contacts'"
              [type]="'Contact'"
              [agency_id]="leadForm.controls['agencyid'].value ? leadForm.controls['agencyid'].value : null"
              [contact_type]="leadForm.controls['lead_type'].value == 'Agent' ? 'Agent' : ''"
              [placeholder]="'Select'"
              [truncate]="25"
              [isMultiple]="false"
              [isClear]="true"
              [selected_ids]="existingContactId"
              (onUpdate)="onUpdateSelect('contact', $event)"
              [isFullObject]="true"
              [style]="{ width: '100%' }"
              [isEmail]="true"
              [isCreateNew]="true"
              (createNew)="openRightModal($event)">
            </re-multiselect>
          </label>
        </div>
        <div class="position-relative top-btns">
          <button class="_cancel-btn mr-2 bg-white" (click)="closeLead()">Close</button>
          <button class="_primary-btn" type="button" [disabled]="saveBtnDisable" (click)="saveLead('create')" [class.disabled]="saveBtnDisable">
            Save & Close
          </button>
        </div>
      </div>
    </div>
  </div>
  <form [formGroup]="leadForm" class="form">
    <div class="d-flex gap-3 {{ leadForm.controls['lead_type'].value == 'Agent' ? 'align-items-stretch' : 'align-items-start' }}">
      <div class="col-sm-7 d-flex flex-column gap-3 px-0">
        <div class="popup-gray-box">
          <p class="f-14 _fw-600 mb-2">Lead Details</p>
          <div class="row lead-details-row">
            <div class="col-sm-2 pr-0">
              <div class="form-group mb-2">
                <label for="firstname">Lead Type</label>
                <ng-select
                  [items]="lead_Type"
                  bindLabel="tag_name"
                  bindValue="tag_name"
                  [searchable]="true"
                  placeholder="Select Type"
                  [clearable]="true"
                  id="type"
                  name="type"
                  [ngClass]="{ '_input-error': isFieldInvalid('lead_type') && !leadForm.controls['lead_type'].value }"
                  formControlName="lead_type"
                  (change)="allocateTagsToFields('lead-status')">
                  <ng-template ng-option-tmp let-item="item">
                    <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group mb-2">
                <label for="firstname">Lead Status</label>
                <ng-select
                  [items]="lead_Status"
                  bindLabel="tag_name"
                  bindValue="tag_name"
                  [searchable]="true"
                  placeholder="Select Status"
                  [clearable]="true"
                  id="status"
                  name="status"
                  formControlName="lead_status"
                  [ngClass]="{ '_input-error': isFieldInvalid('lead_status') && !leadForm.controls['lead_status'].value }"
                  (change)="changeLeadStatus($event)">
                  <ng-template ng-option-tmp let-item="item">
                    <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
            <div class="col-sm-3 pl-0" *ngIf="leadForm.controls['lead_type'].value == 'Agent'">
              <div class="form-group mb-2">
                <label for="lastname">Agreement Status</label>
                <ng-select
                  [items]="agreementList"
                  bindLabel="tag_name"
                  bindValue="tag_name"
                  [searchable]="true"
                  placeholder="Select Agreement Status"
                  [clearable]="true"
                  id="agreement"
                  name="agreement"
                  [ngClass]="{ '_input-error': isFieldInvalid('agreement') && !leadForm.controls['agreement'].value }"
                  formControlName="agreement">
                  <ng-template ng-option-tmp let-item="item">
                    <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
            <div class="col-sm-3 pl-0">
              <div class="form-group mb-2">
                <label for="firstname">Lead Source</label>
                <ng-select
                  [items]="lead_Source"
                  bindLabel="tag_name"
                  bindValue="tag_name"
                  [searchable]="true"
                  placeholder="Select Source"
                  [clearable]="true"
                  id="source"
                  name="source"
                  [ngClass]="{ '_input-error': isFieldInvalid('lead_source') && !leadForm.controls['lead_source'].value }"
                  formControlName="lead_source">
                  <ng-template ng-option-tmp let-item="item">
                    <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
            <div class="col-sm-3 pl-0">
              <div class="form-group mb-2">
                <label for="firstname">Enquiry Type</label>
                <ng-select
                  [items]="enquiry_Type"
                  bindLabel="tag_name"
                  bindValue="tag_name"
                  [searchable]="true"
                  placeholder="Select Type"
                  [clearable]="true"
                  id="enquiry_type"
                  name="enquiry_type"
                  [ngClass]="{ '_input-error': isFieldInvalid('enquiry_type') && !leadForm.controls['enquiry_type'].value }"
                  formControlName="enquiry_type">
                  <ng-template ng-option-tmp let-item="item">
                    <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
            <div class="col-sm-3">
              <label for="firstname">Lead Purpose</label>
              <ng-select
                [items]="lead_category"
                bindLabel="name"
                bindValue="value"
                [searchable]="true"
                placeholder="Lead Enquiry"
                [clearable]="true"
                id="lead_category"
                name="lead_category"
                formControlName="lead_category"
                [ngClass]="{ '_input-error': leadForm.controls['lead_category'].value }"
                (change)="resetFieldOnChange()">
                <ng-template ng-option-tmp let-item="item">
                  <div tooltipPosition="top" [pTooltip]="item.name">{{ item.name }}</div>
                </ng-template>
              </ng-select>
            </div>
            <ng-container *ngIf="leadForm.controls['lead_category'].value === 'project'">
              <div class="col-sm-6 pl-0">
                <div class="form-group mb-2">
                  <label for="lastname">Project Name</label>
                  <ng-select
                    [items]="lmService?.ProjectList"
                    bindLabel="Project_Name"
                    bindValue="_id"
                    [searchable]="true"
                    placeholder="Select Project"
                    [clearable]="true"
                    id="status"
                    name="status"
                    formControlName="project"
                    [ngClass]="{ '_input-error': isFieldInvalid('project') && !leadForm.controls['project'].value }"
                    [addTag]="addCustomProject"
                    (change)="getProjectDetails()">
                    <ng-template ng-option-tmp let-item="item">
                      <div tooltipPosition="top" [pTooltip]="item.Project_Name">{{ item.Project_Name }}</div>
                    </ng-template>
                  </ng-select>
                </div>
              </div>
              <!-- Only set when the lead came from a listing that is a lot; it reports which lot
                   rather than offering a choice, so it is read-only. -->
              <div class="col-sm-3 pl-0" *ngIf="residentialLotOptions?.length">
                <div class="form-group mb-2">
                  <label for="residentialProjectLot">Residential Project Lot</label>
                  <ng-select
                    [items]="residentialLotOptions"
                    bindLabel="lot_name"
                    bindValue="_id"
                    id="residentialProjectLot"
                    name="residentialProjectLot"
                    formControlName="lot_id"
                    [readonly]="true"
                    [clearable]="false"
                    [searchable]="false"
                    placeholder="Select Lot">
                  </ng-select>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="leadForm.controls['lead_category'].value === 'listing'">
              <div class="col-sm-6 pl-0">
                <div class="form-group mb-2">
                  <label for="lastname">Listing Address</label>
                  <ng-select
                    [items]="all_listing"
                    bindLabel="property_address"
                    bindValue="_id"
                    [searchable]="true"
                    placeholder="Select Listing"
                    [clearable]="true"
                    id="Listing"
                    name="Listing"
                    formControlName="listing"
                    [ngClass]="{ '_input-error': isFieldInvalid('listing') && !leadForm.controls['listing'].value }"
                    (change)="getListingValue($event)">
                    <ng-template ng-option-tmp let-item="item">
                      <div tooltipPosition="top" [pTooltip]="item.property_address">{{ item.property_address }}</div>
                    </ng-template>
                  </ng-select>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="leadForm.controls['lead_category'].value === 'property'">
              <div class="col-sm-6 pl-0">
                <div class="form-group mb-2">
                  <label for="lastname">Property Address</label>
                  <ng-select
                    [items]="all_property"
                    bindLabel="property_address"
                    bindValue="_id"
                    [searchable]="true"
                    formControlName="property"
                    name="seller"
                    placeholder="Select Property"
                    [clearable]="true"
                    id="Listing"
                    [ngClass]="{ '_input-error': isFieldInvalid('property') && !leadForm.controls['property'].value }"
                    (change)="getListingValue($event)">
                    <ng-template ng-header-tmp>
                      <a href="javascript:void(0)" (click)="create_element = 'property'; openPopup('property')" class="link-color">
                        <i class="fa fa-plus"></i> Create new
                      </a>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                      <span tooltipPosition="top" [pTooltip]="item.property_address">{{ item.property_address }}</span>
                    </ng-template>
                  </ng-select>
                </div>
              </div>
            </ng-container>
            <div class="col-sm-3 {{ !residentialLotOptions?.length && 'pl-0' }}">
              <div class="form-group mb-2">
                <label for="lastname">Agent Responsible</label>
                <!-- <ng-select
                #agentSelect
                [items]="isAgentResponsibleTeam ? teamList : staff_user"
                bindLabel="full_name"
                bindValue="_id"
                [searchable]="true"
                placeholder="Select Agent"
                [clearable]="true"
                id="status"
                name="status"
                [ngClass]="{ '_input-error': isFieldInvalid('agent_responsible') && !leadForm.controls['agent_responsible'].value }"
                formControlName="agent_responsible">
                <ng-template ng-header-tmp>
                  <div class="active-inactive-status d-flex justify-content-between align-items-center mb-1">
                    <p class="m-0">{{ isAgentResponsibleTeam == true ? 'Teams' : 'Users' }}</p>
                    <div class="SP-switch">
                      <p-inputSwitch [(ngModel)]="isAgentResponsibleTeam" [ngModelOptions]="{ standalone: true }" (onChange)="refocusSelectSearch(agentSelect)">
                      </p-inputSwitch>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                  <div tooltipPosition="top" [pTooltip]="item?.email ? item.full_name + ' (' + item.email + ')' : item.full_name">
                    {{ item?.email ? item.full_name + ' (' + item.email + ')' : item.full_name }}
                  </div>
                </ng-template>
              </ng-select> -->
                <ng-select
                  [items]="staff_user"
                  bindLabel="full_name"
                  bindValue="_id"
                  [searchable]="true"
                  placeholder="Select Agent"
                  [clearable]="true"
                  id="status"
                  name="status"
                  [ngClass]="{ '_input-error': isFieldInvalid('agent_responsible') && !leadForm.controls['agent_responsible'].value }"
                  formControlName="agent_responsible">
                  <ng-template ng-option-tmp let-item="item">
                    <div tooltipPosition="top" [pTooltip]="item?.email ? item.full_name + ' (' + item.email + ')' : item.full_name">
                      {{ item?.email ? item.full_name + ' (' + item.email + ')' : item.full_name }}
                    </div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
            <div
              class="col-sm-3 {{
                leadForm.controls['lead_category'].value == 'requirement' || !leadForm.controls['lead_category'].value ? 'pl-0' : ''
              }} {{ residentialLotOptions?.length && 'pl-0' }}">
              <div class="form-group mb-2">
                <label for="firstname">Owner</label>
                <ng-select
                  #ownerSelect
                  [items]="isOwnerTeam ? teamList : staff_user"
                  bindLabel="full_name"
                  bindValue="_id"
                  [searchable]="true"
                  placeholder="Select Owner"
                  [clearable]="true"
                  id="status"
                  name="status"
                  [ngClass]="{ '_input-error': isFieldInvalid('Owner') && !leadForm.controls['Owner'].value }"
                  formControlName="Owner">
                  <ng-template ng-header-tmp>
                    <div class="active-inactive-status d-flex justify-content-between align-items-center mb-1">
                      <p class="m-0">{{ isOwnerTeam == true ? 'Teams' : 'Users' }}</p>
                      <div class="SP-switch">
                        <p-inputSwitch
                          [(ngModel)]="isOwnerTeam"
                          [ngModelOptions]="{ standalone: true }"
                          (onChange)="refocusSelectSearch(ownerSelect)">
                        </p-inputSwitch>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item">
                    <div tooltipPosition="top" [pTooltip]="item?.email ? item.full_name + ' (' + item.email + ')' : item.full_name">
                      {{ item?.email ? item.full_name + ' (' + item.email + ')' : item.full_name }}
                    </div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
            <div class="col-sm-3 pl-0">
              <div class="form-group mb-2">
                <label for="firstname">Created</label>
                <p-calendar formControlName="created_at" dateFormat="dd/mm/yy" placeholder="Created On" (onSelect)="selectDate()"></p-calendar>
              </div>
            </div>
            <div
              class="col-sm-2  {{
                leadForm.controls['lead_category'].value && leadForm.controls['lead_category'].value !== 'requirement' ? 'pl-0' : ''
              }}">
              <label>Time</label>
              <p-calendar formControlName="time" [timeOnly]="true" [hourFormat]="12" />
            </div>
            <!-- <div class="col-sm-3 pl-0">
            <div class="form-group mb-2">
              <label for="sub_office_id">Sub Office</label>
              <ng-select
                [items]="subOfficeList"
                bindLabel="office_name"
                bindValue="_id"
                [searchable]="true"
                [clearable]="true"
                placeholder="Select Sub Office"
                formControlName="sub_office_id"></ng-select>
            </div>
          </div> -->
            <div class="col-sm-4 pl-0 {{ mobToggle ? 'px-0' : '' }}" *ngIf="leadForm.controls['lead_status'].value == 'No Further Interest'">
              <label for="firstname">No Further Interest</label>
              <ng-select
                [items]="not_interested_reason"
                bindLabel="tag_name"
                bindValue="tag_name"
                [searchable]="true"
                placeholder="Select Status"
                [clearable]="true"
                id="status"
                name="status"
                formControlName="not_interested"
                [ngClass]="{ '_input-error': isFieldInvalid('not_interested') && !leadForm.controls['not_interested'].value }"
                class="{{ mobToggle ? 'w-100' : 'w-75' }}">
                <ng-template ng-option-tmp let-item="item">
                  <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                </ng-template>
              </ng-select>
            </div>
          </div>
        </div>
        <ng-container *ngIf="leadForm.controls['lead_type'].value == 'Agent'">
          <div class="popup-gray-box flex-grow-1">
            <p class="f-14 _fw-600 mb-2 px-0">Lead Information</p>
            <div class="row">
              <div class="col-sm-4">
                <div class="form-group mb-2">
                  <label for="lastname">Project Information Sent</label>
                  <p-calendar
                    formControlName="project_information_sent_date"
                    dateFormat="dd/mm/yy"
                    [ngClass]="{
                      invalidCalendarField:
                        isFieldInvalid('project_information_sent_date') && !leadForm.controls['project_information_sent_date'].value,
                    }"
                    placeholder="Project Information Sent Date"
                    (onSelect)="selectDate()"></p-calendar>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group mb-2">
                  <label for="lastname">Agreement Sent</label>
                  <p-calendar
                    formControlName="agreement_sent_date"
                    dateFormat="dd/mm/yy"
                    [ngClass]="{ invalidCalendarField: isFieldInvalid('agreement_sent_date') && !leadForm.controls['agreement_sent_date'].value }"
                    placeholder="Agreement Sent Date"
                    (onSelect)="selectDate()"></p-calendar>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3">
                <p class="mb-1">Briefing</p>
                <p-calendar
                  formControlName="personal_briefing_date"
                  dateFormat="dd/mm/yy"
                  placeholder="dd/mm/yy"
                  [ngClass]="{ invalidCalendarField: isFieldInvalid('personal_briefing_date') && !leadForm.controls['personal_briefing_date'].value }"
                  (onSelect)="selectDate()">
                </p-calendar>
              </div>
              <div class="col-sm-3 pl-0">
                <p class="mb-1">Time</p>
                <ng-select
                  [items]="timer_options"
                  [searchable]="true"
                  placeholder="Time"
                  [clearable]="false"
                  id="type"
                  name="type"
                  [ngClass]="{ '_input-error': isFieldInvalid('personal_briefing_time') && !leadForm.controls['personal_briefing_time'].value }"
                  formControlName="personal_briefing_time">
                </ng-select>
              </div>
              <div class="col-sm-3 pl-0">
                <p class="mb-1">Onsite Training</p>
                <p-calendar
                  formControlName="onsite_training_date"
                  dateFormat="dd/mm/yy"
                  placeholder="dd/mm/yy"
                  [ngClass]="{ invalidCalendarField: isFieldInvalid('onsite_training_date') && !leadForm.controls['onsite_training_date'].value }"
                  (onSelect)="selectDate()">
                </p-calendar>
              </div>
              <div class="col-sm-3 pl-0">
                <p class="mb-1">Time</p>
                <ng-select
                  [items]="timer_options"
                  [searchable]="true"
                  placeholder="Time"
                  [clearable]="false"
                  id="type"
                  name="type"
                  [ngClass]="{ '_input-error': isFieldInvalid('onsite_training_time') && !leadForm.controls['onsite_training_time'].value }"
                  formControlName="onsite_training_time">
                </ng-select>
              </div>
            </div>
            <div class="col-sm-12 mt-3 px-0">
              <p class="mb-1">Comments</p>
              <textarea
                pInputTextarea
                spellcheck="true"
                autoresize="autoResize"
                formControlName="comments"
                style="overflow: auto; height: 100px; border-radius: 16px !important; text-align: justify">
              </textarea>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="col-sm-5 popup-gray-box w-40Percent">
        <div class="row">
          <ng-container *ngIf="companyInfo; else noCompany">
            <div class="row mt-3">
              <div class="d-flex align-items-center justify-content-between mb-3 px-0">
                <p class="f-14 _fw-600 m-0">Company Details</p>
                <ng-container *ngIf="leadForm.controls['lead_type'].value == 'Agent'" [ngTemplateOutlet]="buyerToggle"></ng-container>
              </div>
              <div class="d-flex align-items-center mb-2" *ngIf="companyInfo['name']">
                <p class="w-85">{{ leadForm.controls['lead_type'].value == 'Agent' ? 'Company Name:' : 'Contact:' }}</p>
                <p class="_fw-600">
                  {{ companyInfo['name'] }}
                </p>
              </div>
              <div class="d-flex align-items-center mb-2" *ngIf="companyInfo['mobile_no']">
                <p class="w-85">Mobile:</p>
                <p class="link-contact-email" (click)="dialCall(companyInfo['mobile_no'])">
                  {{ companyInfo['mobile_no'] }}
                </p>
              </div>
              <div class="d-flex align-items-center mb-2" *ngIf="companyInfo['email']">
                <p class="w-85">Email:</p>
                <p class="link-contact-email">
                  <a href="mailto:{{ companyInfo['email'] }}" class="text-dark">
                    {{ companyInfo['email'] }}
                  </a>
                </p>
              </div>
            </div>
          </ng-container>
          <ng-template #noCompany>
            <ng-container *ngIf="leadForm.controls['lead_type'].value == 'Agent'">
              <div class="d-flex align-items-center justify-content-between mb-2">
                <p class="f-14 _fw-600 m-0">Agency Details</p>
                <ng-container [ngTemplateOutlet]="buyerToggle"></ng-container>
              </div>
              <div class="row pr-0">
                <div class="col-sm-12 pr-0">
                  <div class="form-group mb-2">
                    <label for="agency_name">Agency Name</label>
                    <input type="text" formControlName="agency_name" />
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group mb-2">
                    <label for="agency_contact_number">Phone</label>
                    <input type="text" formControlName="agency_mobile_number" />
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group mb-2">
                    <label for="agency_contact_number">Website</label>
                    <input type="text" formControlName="agency_website" />
                  </div>
                </div>
                <div class="col-sm-4 pr-0">
                  <div class="form-group mb-2">
                    <label for="agency_email">Agency Email</label>
                    <input type="text" formControlName="agency_email" />
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-template>
        </div>
        <p class="f-14 _fw-600 mb-2 mt-3">
          {{ leadForm.controls['lead_type'].value == 'Agent' ? 'Agent Details' : 'Contact Details' }}
        </p>
        <div class="row">
          <ng-container *ngIf="existingContactId; else noExistingContact">
            <div class="d-flex align-items-center mt-3 mb-2">
              <p class="w-85">{{ leadForm.controls['lead_type'].value == 'Agent' ? 'Agent Name:' : 'Contact:' }}</p>
              <p class="_fw-600 cursor-pointer" (click)="openPopup('contact')" *ngIf="contactInfo['full_name']">
                {{ contactInfo['full_name'] }}
              </p>
            </div>
            <div class="d-flex align-items-center mb-2" *ngIf="contactInfo['mobile_no']">
              <p class="w-85">Mobile:</p>
              <p class="link-contact-email" (click)="dialCall(contactInfo['mobile_no'])">
                {{ contactInfo['mobile_no'] | mobileFormat }}
              </p>
            </div>
            <div class="d-flex align-items-center mb-2" *ngIf="contactInfo['email']">
              <p class="w-85">Email:</p>
              <p class="link-contact-email">
                <a href="mailto:{{ contactInfo['email'] }}" class="text-dark">
                  {{ contactInfo['email'] }}
                </a>
              </p>
            </div>
          </ng-container>
          <ng-template #noExistingContact>
            <ng-container *ngIf="!leadForm.controls['lead_type'].value?.includes('Developer'); else yesDeveloper">
              <div class="col-sm-4">
                <div class="form-group mb-2">
                  <label for="lastname">First Name</label>
                  <ng-container *ngIf="isFieldDisabled == false; else fName">
                    <input type="text" formControlName="first_name" />
                  </ng-container>
                  <ng-template #fName>
                    <p class="readonly-name" (click)="openPopup('contact')">
                      {{ leadForm.controls['first_name'].value }}
                    </p>
                  </ng-template>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group mb-2">
                  <label for="firstname">Last Name</label>
                  <ng-container *ngIf="isFieldDisabled == false; else lName">
                    <input type="text" formControlName="last_name" />
                  </ng-container>
                  <ng-template #lName>
                    <p class="readonly-name" (click)="openPopup('contact')">
                      {{ leadForm.controls['last_name'].value }}
                    </p>
                  </ng-template>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group mb-2">
                  <label for="lastname">Mobile Phone</label>
                  <ng-container *ngIf="isFieldDisabled == false; else mName">
                    <input type="text" formControlName="mobile_phone" appMobileMask placeholder="0000 000 000" />
                    <div *ngIf="checkValidation(this.leadForm.controls['mobile_phone'].value)">
                      <p class="text-danger mt-2">Only numbers are allowed.</p>
                    </div>
                  </ng-container>
                  <ng-template #mName>
                    <p class="readonly-field">{{ leadForm.controls['mobile_phone'].value }}</p>
                  </ng-template>
                </div>
              </div>
              <ng-container *ngIf="leadForm.controls['lead_type'].value == 'Agent'">
                <div class="col-sm-4">
                  <div class="form-group mb-2">
                    <label for="agency_position">Position</label>
                    <ng-select
                      [items]="companyRole"
                      bindLabel="tag_name"
                      bindValue="tag_name"
                      [searchable]="true"
                      placeholder="Select Position"
                      [clearable]="true"
                      id="agency_position"
                      name="agency_position"
                      formControlName="position">
                    </ng-select>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group mb-2">
                    <label for="agency_position">WeChat</label>
                    <input type="text" formControlName="wechat" />
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="firstname">Country</label>
                    <ng-container *ngIf="isFieldDisabled == false; else conName">
                      <ng-select
                        [items]="countries"
                        bindLabel="name"
                        bindValue="name"
                        [searchable]="true"
                        placeholder="Select Country"
                        [clearable]="true"
                        id="country"
                        name="country"
                        formControlName="countryregion">
                        <ng-template ng-option-tmp let-item="item">
                          <div tooltipPosition="top" [pTooltip]="item.name">{{ item.name }}</div>
                        </ng-template>
                      </ng-select>
                    </ng-container>
                    <ng-template #conName>
                      <p class="readonly-field">{{ leadForm.controls['countryregion'].value }}</p>
                    </ng-template>
                  </div>
                </div>
              </ng-container>
              <div class="col-sm-8">
                <div class="form-group">
                  <label for="firstname">Email</label>
                  <ng-container *ngIf="isFieldDisabled == false; else eName">
                    <input type="text" formControlName="email" />
                  </ng-container>
                  <ng-template #eName>
                    <p class="readonly-field">{{ leadForm.controls['email'].value }}</p>
                  </ng-template>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label for="firstname">Suburb</label>
                  <ng-container *ngIf="isFieldDisabled == false; else sName">
                    <input type="text" formControlName="suburb" />
                  </ng-container>
                  <ng-template #sName>
                    <p class="readonly-field">{{ leadForm.controls['suburb'].value }}</p>
                  </ng-template>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label for="firstname">Postcode</label>
                  <ng-container *ngIf="isFieldDisabled == false; else pName">
                    <input type="text" formControlName="postcode" placeholder="e.g. 4101" [maxlength]="postcodeMaxLength" />
                    <small class="d-block f-10 mt-1 searchIcon-color" *ngIf="isNonAuPostcode(leadForm.controls['postcode'].value)">
                      AU postcodes are 4 digits
                    </small>
                  </ng-container>
                  <ng-template #pName>
                    <p class="readonly-field">{{ leadForm.controls['postcode'].value }}</p>
                  </ng-template>
                </div>
              </div>
              <div class="col-sm-4" *ngIf="leadForm.controls['lead_type'].value !== 'Agent'">
                <div class="form-group">
                  <label for="firstname">Country</label>
                  <ng-container *ngIf="isFieldDisabled == false; else conName">
                    <ng-select
                      [items]="countries"
                      bindLabel="name"
                      bindValue="name"
                      [searchable]="true"
                      placeholder="Select Country"
                      [clearable]="true"
                      id="country"
                      name="country"
                      formControlName="countryregion">
                      <ng-template ng-option-tmp let-item="item">
                        <div tooltipPosition="top" [pTooltip]="item.name">{{ item.name }}</div>
                      </ng-template>
                    </ng-select>
                  </ng-container>
                  <ng-template #conName>
                    <p class="readonly-field">{{ leadForm.controls['countryregion'].value }}</p>
                  </ng-template>
                </div>
              </div>
            </ng-container>
            <ng-template #yesDeveloper>
              <div class="col-sm-4">
                <div class="form-group mb-2">
                  <label for="lastname">First Name</label>
                  <ng-container *ngIf="isFieldDisabled == false; else fName">
                    <input type="text" formControlName="first_name" />
                  </ng-container>
                  <ng-template #fName>
                    <p class="readonly-name" (click)="openPopup('contact')">
                      {{ leadForm.controls['first_name'].value }}
                    </p>
                  </ng-template>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group mb-2">
                  <label for="firstname">Last Name</label>
                  <ng-container *ngIf="isFieldDisabled == false; else lName">
                    <input type="text" formControlName="last_name" />
                  </ng-container>
                  <ng-template #lName>
                    <p class="readonly-name" (click)="openPopup('contact')">
                      {{ leadForm.controls['last_name'].value }}
                    </p>
                  </ng-template>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group mb-2">
                  <label for="firstname">Company Name</label>
                  <ng-container *ngIf="isFieldDisabled == false; else cName">
                    <input type="text" formControlName="company" />
                  </ng-container>
                  <ng-template #cName>
                    <p class="readonly-field">{{ leadForm.controls['company'].value }}</p>
                  </ng-template>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group mb-2">
                  <label for="lastname">Mobile Phone</label>
                  <ng-container *ngIf="isFieldDisabled == false; else mName">
                    <input type="text" formControlName="mobile_phone" />
                  </ng-container>
                  <ng-template #mName>
                    <p class="readonly-field">{{ leadForm.controls['mobile_phone'].value }}</p>
                  </ng-template>
                </div>
              </div>
              <div class="col-sm-8">
                <div class="form-group">
                  <label for="firstname">Email</label>
                  <ng-container *ngIf="isFieldDisabled == false; else eName">
                    <input type="text" formControlName="email" />
                  </ng-container>
                  <ng-template #eName>
                    <p class="readonly-field">{{ leadForm.controls['email'].value }}</p>
                  </ng-template>
                </div>
              </div>
            </ng-template>
          </ng-template>
        </div>
        <!--<ng-container *ngIf="leadForm.controls['lead_type'].value !== 'Agent'">
          <p class="f-14 _fw-600 mb-2 mt-3">Alternate Contact</p>
          <div class="row">
            <div class="col-sm-4">
              <div class="form-group mb-2">
                <label for="lastname">First Name</label>
                <input type="text" formControlName="alternate_first_name" />
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group mb-2">
                <label for="firstname">Last Name</label>
                <input type="text" formControlName="alternat_last_name" />
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group mb-2">
                <label for="lastname">Mobile Phone</label>
                <input type="text" formControlName="alternate_mobile" appMobileMask placeholder="0000 000 000" />
              </div>
            </div>
            <div class="col-sm-8">
              <div class="form-group">
                <label for="firstname">Email</label>
                <input type="text" formControlName="alternate_email" />
              </div>
            </div>
          </div>
        </ng-container> -->
        <ng-container *ngIf="leadForm.controls['lead_type'].value == 'Agent' && leadForm.controls['buyer_detail_exist'].value">
          <p class="f-14 _fw-600 mb-2 mt-3">Buyer Details</p>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group mb-2">
                <label>Buyer</label>
                <re-multiselect
                  [module]="'contacts'"
                  [type]="'Contact'"
                  [placeholder]="'Search Buyer'"
                  [truncate]="25"
                  [isMultiple]="false"
                  [isClear]="true"
                  [selected_ids]="buyerSelectedIds"
                  (onUpdate)="onBuyerSelect($event)"
                  [isFullObject]="true"
                  [style]="{ width: '100%' }"
                  [isEmail]="true"
                  [isCreateNew]="true"
                  (createNew)="openBuyerRightModal()">
                </re-multiselect>
              </div>
            </div>
            <ng-container *ngIf="buyerInfo">
              <div class="d-flex align-items-center mt-2 mb-2">
                <p class="w-85">Buyer Name:</p>
                <p class="_fw-600">{{ buyerInfo['full_name'] }}</p>
              </div>
              <div class="d-flex align-items-center mb-2" *ngIf="buyerInfo['mobile_no']">
                <p class="w-85">Mobile:</p>
                <p class="link-contact-email" (click)="dialCall(buyerInfo['mobile_no'])">
                  {{ buyerInfo['mobile_no'] | mobileFormat }}
                </p>
              </div>
              <div class="d-flex align-items-center mb-2" *ngIf="buyerInfo['email']">
                <p class="w-85">Email:</p>
                <p class="link-contact-email">
                  <a href="mailto:{{ buyerInfo['email'] }}" class="text-dark">
                    {{ buyerInfo['email'] }}
                  </a>
                </p>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="row popup-gray-box mt-3 m-0" *ngIf="leadForm.controls['lead_type'].value && leadForm.controls['lead_type'].value !== 'Agent'">
      <p class="f-14 _fw-600 mb-2 px-0">
        {{ leadForm.controls['lead_type'].value == 'Developer' ? 'Developer Requirements' : 'Requirements' }}
      </p>
      <ng-container *ngIf="leadForm.controls['lead_type'].value == 'Buyer'">
        <div class="col-sm-2 pl-0">
          <div class="form-group mb-2">
            <label for="lastname">Property Type</label>
            <ng-select
              [items]="property_Type"
              bindLabel="tag_name"
              bindValue="tag_name"
              [searchable]="true"
              placeholder="Select Property Type"
              [clearable]="true"
              id="Listing"
              name="Listing"
              [ngClass]="{ '_input-error': isFieldInvalid('listing_type') && !leadForm.controls['listing_type'].value }"
              formControlName="listing_type">
              <ng-template ng-option-tmp let-item="item">
                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
        <div class="col-sm-2">
          <div class="form-group mb-2">
            <label for="priceRange">Price Range</label>
            <ng-select
              [items]="budgetList"
              bindLabel="tag_name"
              bindValue="tag_name"
              [searchable]="true"
              placeholder="Select"
              [clearable]="true"
              id="Listing"
              name="Listing"
              [ngClass]="{ '_input-error': isFieldInvalid('price_range') && !leadForm.controls['price_range'].value }"
              formControlName="price_range">
              <ng-template ng-option-tmp let-item="item">
                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
        <div class="col-sm-2">
          <div class="form-group">
            <label for="firstname">Bedrooms</label>
            <ng-select
              [items]="bedrooms"
              bindLabel="bed"
              bindValue="bed"
              [searchable]="true"
              placeholder="Select"
              [clearable]="true"
              id="bed"
              name="bed"
              [ngClass]="{ '_input-error': isFieldInvalid('beds') && !leadForm.controls['beds'].value }"
              formControlName="beds">
              <ng-template ng-option-tmp let-item="item">
                <div tooltipPosition="top" [pTooltip]="item.bed">{{ item.bed }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
        <div class="col-sm-2">
          <div class="form-group">
            <label for="firstname">Bathrooms</label>
            <ng-select
              [items]="bathrooms"
              bindLabel="bath"
              bindValue="bath"
              [searchable]="true"
              placeholder="Bathrooms"
              [clearable]="true"
              id="bed"
              name="bed"
              [ngClass]="{ '_input-error': isFieldInvalid('baths') && !leadForm.controls['baths'].value }"
              formControlName="baths">
              <ng-template ng-option-tmp let-item="item">
                <div tooltipPosition="top" [pTooltip]="item.bath">{{ item.bath }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
        <div class="col-sm-2">
          <div class="form-group">
            <label for="firstname">Car Parks</label>
            <ng-select
              [items]="bathrooms"
              bindLabel="bath"
              bindValue="bath"
              [searchable]="true"
              placeholder="Car parks"
              [clearable]="true"
              id="car"
              name="car"
              [ngClass]="{ '_input-error': isFieldInvalid('car') && !leadForm.controls['car'].value }"
              formControlName="car">
              <ng-template ng-option-tmp let-item="item">
                <div tooltipPosition="top" [pTooltip]="item.bath">{{ item.bath }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
        <div class="col-sm-2">
          <div class="form-group">
            <label for="firstname">Buyer Timeframe</label>
            <ng-select
              [items]="time_frame"
              bindLabel="tag_name"
              bindValue="tag_name"
              [searchable]="true"
              placeholder="Time Frame"
              [clearable]="true"
              id="time_frame"
              name="time_frame"
              [ngClass]="{ '_input-error': isFieldInvalid('time_frame') && !leadForm.controls['time_frame'].value }"
              formControlName="time_frame">
              <ng-template ng-option-tmp let-item="item">
                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
        <div class="col-sm-2 pl-0">
          <div class="form-group">
            <label for="firstname">Land Size</label>
            <ng-select
              [items]="land_size"
              bindLabel="land_size"
              bindValue="land_size"
              [searchable]="true"
              placeholder="Min"
              [clearable]="true"
              id="land_size"
              name="land_size"
              [ngClass]="{ '_input-error': isFieldInvalid('min_land_area') && !leadForm.controls['min_land_area'].value }"
              formControlName="min_land_area">
              <ng-template ng-option-tmp let-item="item">
                <div tooltipPosition="top" [pTooltip]="item.land_size">{{ item.land_size }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
        <div class="col-sm-2">
          <div class="form-group">
            <label for="firstname"></label>
            <ng-select
              [items]="land_size"
              bindLabel="land_size"
              bindValue="land_size"
              [searchable]="true"
              placeholder="Max"
              [clearable]="true"
              class="mt-1"
              id="land_size"
              name="land_size"
              [ngClass]="{ '_input-error': isFieldInvalid('max_land_area') && !leadForm.controls['max_land_area'].value }"
              formControlName="max_land_area">
              <ng-template ng-option-tmp let-item="item">
                <div tooltipPosition="top" [pTooltip]="item.land_size">{{ item.land_size }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
        <div class="col-sm-2">
          <div class="form-group">
            <label for="firstname">New or Established</label>
            <ng-select
              [items]="Established_property"
              bindLabel="tag_name"
              bindValue="tag_name"
              [searchable]="true"
              placeholder="Established Property"
              [clearable]="true"
              id="established_property"
              name="established_property"
              [ngClass]="{ '_input-error': isFieldInvalid('established_property') && !leadForm.controls['established_property'].value }"
              formControlName="established_property">
              <ng-template ng-option-tmp let-item="item">
                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
        <div class="col-sm-2">
          <div class="form-group">
            <label for="firstname">Intended Use</label>
            <ng-select
              [items]="intended_use"
              bindLabel="tag_name"
              bindValue="tag_name"
              [searchable]="true"
              placeholder="Intended Use"
              [clearable]="true"
              id="intended_use"
              name="intended_use"
              [ngClass]="{ '_input-error': isFieldInvalid('intended_use') && !leadForm.controls['intended_use'].value }"
              formControlName="intended_use">
              <ng-template ng-option-tmp let-item="item">
                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
        <div class="col-sm-2">
          <div class="form-group">
            <label for="firstname">Outdoor Feature</label>
            <re-multiSelect
              [options]="outdoor_feature"
              formControlName="outdoor_feature"
              optionLabel="tag_name"
              optionValue="tag_name"
              placeholder="Outdoor"
              [required_class]="isFieldInvalid('outdoor_feature') && !leadForm.controls['outdoor_feature'].value ? 'is-invalid' : ''">
            </re-multiSelect>
          </div>
        </div>
        <div class="col-sm-2">
          <div class="form-group">
            <label for="firstname">Indoor Feature</label>
            <re-multiSelect
              [options]="indoor_feature"
              formControlName="indoor_feature"
              optionLabel="tag_name"
              optionValue="tag_name"
              placeholder="Indoor"
              [required_class]="isFieldInvalid('indoor_feature') && !leadForm.controls['indoor_feature'].value ? 'is-invalid' : ''">
            </re-multiSelect>
          </div>
        </div>
        <div class="col-sm-2 pl-0">
          <div class="form-group">
            <label for="firstname">Reason For Buying</label>
            <ng-select
              [items]="reason_for_buying"
              bindLabel="tag_name"
              bindValue="tag_name"
              [searchable]="true"
              placeholder="Reason For Buying"
              [clearable]="true"
              id="reason_for_buying"
              name="reason_for_buying"
              [ngClass]="{ '_input-error': isFieldInvalid('reason_for_buying') && !leadForm.controls['reason_for_buying'].value }"
              formControlName="reason_for_buying">
              <ng-template ng-option-tmp let-item="item">
                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="leadForm.controls['lead_type'].value == 'Seller'">
        <div class="col-sm-3 pl-0">
          <div class="form-group mb-2">
            <label for="lastname">Address</label>
            <input
              class="site-input addressSearch"
              placeholder="Search Address"
              google-places-autocomplete
              [options]="options"
              formControlName="address"
              [ngClass]="{ invalidField: isFieldInvalid('address') && !leadForm.controls['address'].value }"
              (onAddressChange)="handleAddressChange($event, 'address')" />
          </div>
        </div>
        <div class="col-sm-2">
          <div class="form-group mb-2">
            <label for="lastname">Property Type</label>
            <ng-select
              [items]="property_Type"
              bindLabel="tag_name"
              bindValue="tag_name"
              [searchable]="true"
              placeholder="Select Property Type"
              [clearable]="true"
              id="Listing"
              name="Listing"
              [ngClass]="{ '_input-error': isFieldInvalid('listing_type') && !leadForm.controls['listing_type'].value }"
              formControlName="listing_type">
              <ng-template ng-option-tmp let-item="item">
                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
        <div class="col-sm-2">
          <div class="form-group">
            <label for="firstname">Price Range</label>
            <ng-select
              [items]="budgetList"
              bindLabel="tag_name"
              bindValue="tag_name"
              [searchable]="true"
              placeholder="Select"
              [clearable]="true"
              id="Listing"
              name="Listing"
              [ngClass]="{ '_input-error': isFieldInvalid('price_range') && !leadForm.controls['price_range'].value }"
              formControlName="price_range">
              <ng-template ng-option-tmp let-item="item">
                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
        <div class="col-sm-2">
          <div class="form-group">
            <label for="firstname">Bedrooms</label>
            <ng-select
              [items]="bedrooms"
              bindLabel="bed"
              bindValue="bed"
              [searchable]="true"
              placeholder="Select"
              [clearable]="true"
              id="bed"
              name="bed"
              [ngClass]="{ '_input-error': isFieldInvalid('beds') && !leadForm.controls['beds'].value }"
              formControlName="beds">
              <ng-template ng-option-tmp let-item="item">
                <div tooltipPosition="top" [pTooltip]="item.bed">{{ item.bed }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
        <div class="col-sm-2">
          <div class="form-group">
            <label for="firstname">Bathrooms</label>
            <ng-select
              [items]="bathrooms"
              bindLabel="bath"
              bindValue="bath"
              [searchable]="true"
              placeholder="Bathrooms"
              [clearable]="true"
              id="bed"
              name="bed"
              [ngClass]="{ '_input-error': isFieldInvalid('baths') && !leadForm.controls['baths'].value }"
              formControlName="baths">
              <ng-template ng-option-tmp let-item="item">
                <div tooltipPosition="top" [pTooltip]="item.bath">{{ item.bath }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
        <div class="col-sm-2 pl-0">
          <div class="form-group mb-2">
            <label for="lastname">Cars</label>
            <ng-select
              [items]="bathrooms"
              bindLabel="bath"
              bindValue="bath"
              [searchable]="true"
              placeholder="Car parks"
              [clearable]="true"
              id="car"
              name="car"
              [ngClass]="{ '_input-error': isFieldInvalid('car') && !leadForm.controls['car'].value }"
              formControlName="car">
              <ng-template ng-option-tmp let-item="item">
                <div tooltipPosition="top" [pTooltip]="item.bath">{{ item.bath }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
        <div class="col-sm-2 pl-0">
          <div class="form-group">
            <label for="firstname">Selling Timeframe</label>
            <ng-select
              [items]="time_frame"
              bindLabel="tag_name"
              bindValue="tag_name"
              [searchable]="true"
              placeholder="Time Frame"
              [clearable]="true"
              id="time_frame"
              name="time_frame"
              [ngClass]="{ '_input-error': isFieldInvalid('time_frame') && !leadForm.controls['time_frame'].value }"
              formControlName="time_frame">
              <ng-template ng-option-tmp let-item="item">
                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
        <div class="col-sm-2">
          <div class="form-group">
            <label for="firstname">Reason For Selling</label>
            <ng-select
              [items]="reason_for_selling"
              bindLabel="tag_name"
              bindValue="tag_name"
              [searchable]="true"
              placeholder="Reason For Selling"
              [clearable]="true"
              id="reason_for_selling"
              name="reason_for_selling"
              [ngClass]="{ '_input-error': isFieldInvalid('reason_for_selling') && !leadForm.controls['reason_for_selling'].value }"
              formControlName="reason_for_selling">
              <ng-template ng-option-tmp let-item="item">
                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
        <div class="col-sm-2">
          <div class="form-group">
            <label for="firstname">Current Purpose</label>
            <ng-select
              [items]="current_purpose"
              bindLabel="tag_name"
              bindValue="tag_name"
              [searchable]="true"
              placeholder="Current Purpose"
              [clearable]="true"
              id="current_purpose"
              name="current_purpose"
              [ngClass]="{ '_input-error': isFieldInvalid('current_purpose') && !leadForm.controls['current_purpose'].value }"
              formControlName="current_purpose">
              <ng-template ng-option-tmp let-item="item">
                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
        <div class="col-sm-2">
          <div class="form-group">
            <label for="firstname">Tenancy Details</label>
            <ng-select
              [items]="tenancy_details"
              bindLabel="tag_name"
              bindValue="tag_name"
              [searchable]="true"
              placeholder="Tenancy Details"
              [clearable]="true"
              id="tenancy_details"
              name="tenancy_details"
              [ngClass]="{ '_input-error': isFieldInvalid('tenancy_details') && !leadForm.controls['tenancy_details'].value }"
              formControlName="tenancy_details">
              <ng-template ng-option-tmp let-item="item">
                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
        <div class="col-sm-2">
          <div class="form-group">
            <label for="firstname">Tenancy End Date</label>
            <p-calendar
              formControlName="tenancy_end_date"
              dateFormat="dd/mm/yy"
              placeholder="Tenancy End Date"
              (onSelect)="selectDate()"
              [ngClass]="{ invalidCalendarField: isFieldInvalid('tenancy_end_date') && !leadForm.controls['tenancy_end_date'].value }">
            </p-calendar>
          </div>
        </div>

        <div class="col-sm-3 pl-0">
          <div class="form-group">
            <label for="features">Features</label>
            <re-multiSelect
              [options]="lmService?.property_features"
              formControlName="features"
              optionLabel="feature_name"
              optionValue="feature_name"
              placeholder="Feature"
              [required_class]="isFieldInvalid('feature_name') && !leadForm.controls['feature_name'].value ? 'is-invalid' : ''">
            </re-multiSelect>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="leadForm.controls['lead_type'].value == 'Developer'">
        <div class="col-sm-3 pl-0">
          <div class="form-group mb-2">
            <label for="firstname">Development Type</label>
            <ng-select
              [items]="developmentType"
              bindLabel="tag_name"
              bindValue="tag_name"
              [searchable]="true"
              placeholder="Select Type"
              [clearable]="true"
              id="development_type"
              name="development_type"
              [ngClass]="{ '_input-error': isFieldInvalid('development_type') && !leadForm.controls['development_type'].value }"
              formControlName="development_type">
              <ng-template ng-option-tmp let-item="item">
                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="form-group mb-2">
            <label for="firstname">Project Address</label>
            <input
              class="mt-1 site-input addressSearch"
              placeholder="Search Address"
              google-places-autocomplete
              [options]="options"
              (onAddressChange)="handleAddressChange($event, 'project_address')"
              [ngClass]="{ invalidField: isFieldInvalid('project_address') && !leadForm.controls['project_address'].value }"
              formControlName="project_address" />
          </div>
        </div>
        <div class="col-sm-3">
          <div class="form-group mb-2">
            <label for="firstname">Project Suburb</label>
            <input
              type="text"
              formControlName="project_suburb"
              [ngClass]="{ invalidField: isFieldInvalid('project_suburb') && !leadForm.controls['project_suburb'].value }" />
          </div>
        </div>
        <div class="col-sm-3">
          <div class="form-group mb-2">
            <label for="firstname">Project Status</label>
            <ng-select
              [items]="projectStatus"
              bindLabel="tag_name"
              bindValue="tag_name"
              [searchable]="true"
              placeholder="Select Status"
              [clearable]="true"
              id="project_status"
              name="project_status"
              [ngClass]="{ '_input-error': isFieldInvalid('project_status') && !leadForm.controls['project_status'].value }"
              formControlName="project_status">
              <ng-template ng-option-tmp let-item="item">
                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
        <div class="col-sm-3 pl-0">
          <div class="form-group mb-2">
            <label for="firstname">Lot Quantity</label>
            <input
              type="text"
              formControlName="lot_quantity"
              [ngClass]="{ invalidField: isFieldInvalid('lot_quantity') && !leadForm.controls['lot_quantity'].value }" />
          </div>
        </div>
        <div class="col-sm-3">
          <div class="form-group mb-2">
            <label for="firstname">Currently Marketed</label>
            <ng-select
              class="mt-1"
              formControlName="current_market"
              [items]="currently_marketed"
              bindLabel="tag_name"
              bindValue="tag_name"
              [searchable]="true"
              [multiple]="false"
              [ngClass]="{ '_input-error': isFieldInvalid('current_market') && !leadForm.controls['current_market'].value }"
              placeholder="Select Currently Marketed">
              <ng-template ng-option-tmp let-item="item">
                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="form-group mb-2">
            <label for="firstname">Product Mix</label>
            <input
              type="text"
              formControlName="product_mix"
              [ngClass]="{ invalidField: isFieldInvalid('product_mix') && !leadForm.controls['product_mix'].value }" />
          </div>
        </div>
        <div class="col-sm-3">
          <div class="form-group mb-2">
            <label for="firstname">Price Range</label>
            <ng-select
              [items]="budgetList"
              bindLabel="tag_name"
              bindValue="tag_name"
              [searchable]="true"
              placeholder="Select"
              [clearable]="true"
              id="Listing"
              name="Listing"
              [ngClass]="{ '_input-error': isFieldInvalid('price_range') && !leadForm.controls['price_range'].value }"
              formControlName="price_range">
              <ng-template ng-option-tmp let-item="item">
                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
        <div class="col-sm-3 pl-0">
          <div class="form-group mb-2">
            <label for="firstname">Timeframe</label>
            <ng-select
              [items]="time_frame"
              bindLabel="tag_name"
              bindValue="tag_name"
              [searchable]="true"
              placeholder="Time Frame"
              [clearable]="true"
              id="time_frame"
              name="time_frame"
              [ngClass]="{ '_input-error': isFieldInvalid('time_frame') && !leadForm.controls['time_frame'].value }"
              formControlName="time_frame">
              <ng-template ng-option-tmp let-item="item">
                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="form-group mb-2">
            <label for="firstname">Levels</label>
            <input
              type="text"
              formControlName="levels"
              [ngClass]="{ invalidField: isFieldInvalid('levels') && !leadForm.controls['levels'].value }" />
          </div>
        </div>
        <div class="col-sm-3">
          <div class="form-group mb-2">
            <label for="firstname">Amenities</label>
            <input
              type="text"
              formControlName="amenities"
              [ngClass]="{ invalidField: isFieldInvalid('amenities') && !leadForm.controls['amenities'].value }" />
          </div>
        </div>
      </ng-container>
    </div>
  </form>
  <div class="text-right position-relative mt-3" *ngIf="!embedded">
    <button class="_cancel-btn mr-2 bg-white" (click)="closeLead()">Close</button>
    <button class="_primary-btn" type="button" [disabled]="saveBtnDisable" (click)="saveLead('create')" [class.disabled]="saveBtnDisable">
      Save & Close
    </button>
  </div>
</div>

<app-possible-duplicate-contact
  [(visible)]="contactConflict"
  [contacts]="contactList"
  [newContact]="duplicateContactDraft"
  (assign)="convertToContact(leadInsertedId, $event.contactId, false, $event.addAsAlternate, $event.label)"
  (createNew)="convertToContact(leadInsertedId, null, true)"></app-possible-duplicate-contact>

<ng-template #buyerToggle>
  <div class="d-flex align-items-center gap-2" [formGroup]="leadForm">
    <p-checkbox [binary]="true" inputId="add_buyer_details" formControlName="buyer_detail_exist" (onChange)="onBuyerToggle($event)"></p-checkbox>
    <label class="m-0" for="add_buyer_details">Add Buyer Details</label>
  </div>
</ng-template>
